// dependency-graph-ignore-file
import { viewToCollabJSON } from '@databases/collab/convert/to-collab';
import { type Database } from '@databases/model/database';

import { type DatabaseView } from '../../types';

export function setSavedView(ydb: Database, view: DatabaseView): void {
  ydb.mutate((db) => {
    db.setView(view.id, viewToCollabJSON(view, {}));
  });
}
